import JobStatusFilter from "./Filters/JobStatusFilter";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import { addFilter, removeFilter } from "@store/actions/pdf";
import { connect } from "react-redux";
import React from "react";
import JobTypeFilter from "./Filters/JobTypeFilter";
import RemoveFilterIcon from "@components/Icon/RemoveFilterIcon";
import { AvailableFilters, FilterDateRange } from "@utils/enums";
import { Col, Row } from "react-bootstrap";
import clx from "classnames";
import addDyas from "date-fns/add_days";
import { getFilters } from "@store/selectors/pdf";
import { displayDate } from "@utils/date";
const styles = require("./styles.scss");
const TableFiltering = (props) => {
    const setFilter = (params) => {
        let filter = {};
        if (params.filterType === "DATE_RANGE") {
            filter = {
                ...filter,
                [params.filterName === FilterDateRange.CREATED
                    ? AvailableFilters.CREATED_FROM
                    : AvailableFilters.UPDATED_FROM]: params.filterValue[0],
                [params.filterName === FilterDateRange.CREATED
                    ? AvailableFilters.CREATED_TO
                    : AvailableFilters.UPDATED_TO]: addDyas(params.filterValue[1], 1)
            };
        }
        else {
            filter = {
                [params.filterName]: params.filterValue
            };
        }
        props.addFilter(filter);
    };
    const isDatePicked = (dates) => dates.length === 2;
    const changeDateRange = (dates, filterName) => {
        if (isDatePicked(dates)) {
            setFilter({
                filterName,
                filterValue: dates,
                filterType: "DATE_RANGE"
            });
        }
    };
    const getCurrentRangeFilter = (filter) => {
        const start = props.filters[filter === FilterDateRange.CREATED
            ? AvailableFilters.CREATED_FROM
            : AvailableFilters.UPDATED_FROM];
        const stop = props.filters[filter === FilterDateRange.CREATED
            ? AvailableFilters.CREATED_TO
            : AvailableFilters.UPDATED_TO];
        const startDate = start && displayDate(start);
        const stopDate = stop && displayDate(stop);
        return !start && !stop ? "Select date" : `${startDate} - ${stopDate}`;
    };
    const filters = [
        React.createElement(React.Fragment, null,
            React.createElement(JobTypeFilter, { onChange: setFilter }),
            React.createElement(RemoveFilterIcon, { filter: AvailableFilters.TYPE_NAME })),
        React.createElement(React.Fragment, null,
            React.createElement(Flatpickr, { options: {
                    mode: "range",
                    maxDate: "today"
                }, onChange: dates => changeDateRange(dates, FilterDateRange.CREATED), placeholder: getCurrentRangeFilter(FilterDateRange.CREATED), className: `form-control` }),
            React.createElement(RemoveFilterIcon, { filter: AvailableFilters.CREATED_FROM })),
        React.createElement(React.Fragment, null,
            React.createElement(Flatpickr, { id: "update-date", options: { mode: "range", maxDate: "today" }, onChange: dates => changeDateRange(dates, FilterDateRange.UPDATED), placeholder: getCurrentRangeFilter(FilterDateRange.UPDATED), className: `form-control` }),
            React.createElement(RemoveFilterIcon, { filter: AvailableFilters.UPDATED_FROM })),
        React.createElement(React.Fragment, null,
            React.createElement(JobStatusFilter, { onChange: setFilter }),
            React.createElement(RemoveFilterIcon, { filter: AvailableFilters.STATUS_NAME }))
    ];
    return (React.createElement("tr", null,
        React.createElement("td", null),
        filters.map((filter, i) => (React.createElement("td", { key: i },
            React.createElement(Row, null,
                React.createElement(Col, { className: clx(styles.filterWrapper) }, filter)))))));
};
const mapStateToProps = (state) => ({
    filters: getFilters(state)
});
const mapDispatchToProps = {
    addFilter,
    removeFilter
};
export default connect(mapStateToProps, mapDispatchToProps)(TableFiltering);
